module.exports = __webpack_public_path__ + "img/t2.69d9045a.jpg";